import React, { useEffect, useState } from "react";
import api from "../../utils/axios";
import { projectsNav } from "./Data";
import WorkItems from "./WorkItems";

const Works = () => {
  const [item, setItem] = useState({ name: "all" });
  const [dbProjects, setDbProjects] = useState([]);
  const [projects, setProjects] = useState([]);
  const [active, setActive] = useState(0);
  const [loading, setLoading] = useState(true);

  const fetchWorks = async () => {
    try {
      const res = await api.get("/works");
      setDbProjects(res.data);
    } catch (err) {
      console.error("Failed to fetch works:", err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchWorks();
  }, []);

  useEffect(() => {
    if (item.name === "all") {
      setProjects(dbProjects);
    } else {
      const newProjects = dbProjects.filter((project) => {
        return project.category === item.name.toLowerCase();
      });
      setProjects(newProjects);
    }
  }, [item, dbProjects]);

  const handleClick = (e, index) => {
    setItem({ name: e.target.textContent });
    setActive(index);
  };

  if (loading) {
    return <div style={{ textAlign: "center", padding: "2rem", color: "#888" }}>Loading projects...</div>;
  }

  return (
    <div>
      <div className="work__filter">
        {projectsNav.map((item, index) => {
          return (
            <span
              onClick={(e) => {
                handleClick(e, index);
              }}
              className={`${active === index ? "active-work" : ""} work__item`}
              key={index}
            >
              {item.name}
            </span>
          );
        })}
      </div>
      <div className="work__container container grid">
        {projects.length > 0 ? (
          projects.map((item) => {
            return <WorkItems item={item} key={item._id || item.id} />;
          })
        ) : (
          <div style={{ textAlign: "center", gridColumn: "1 / -1", color: "#888", padding: "2rem 0" }}>
            No projects found in this category.
          </div>
        )}
      </div>
    </div>
  );
};

export default Works;
